













import Vue from 'vue'
import { extractTargetFields } from '@/utils/helper'
import UnlockEventValidator, { Fields, FieldErrors } from '@/utils/validators/form/Event/UnlockEvent'

// Usecases
import UnlockEventUseCase from '@/usecases/event/UnlockEventUseCase'
import LoadEventUseCase from '@/usecases/event/LoadEventUseCase'
import FetchEventUseCase from '@/usecases/event/FetchEventUseCase'
import FetchEventAlbumsUseCase from '@/usecases/event/FetchEventAlbumsUseCase'
import SearchEventUchinokoPhotosUseCase from '@/usecases/event/SearchEventUchinokoPhotosUseCase'
import FetchGroupsUseCase from '@/usecases/group/FetchGroupsUseCase'
import FetchSchoolsUseCase from '@/usecases/school/FetchSchoolsUseCase'
import FetchGroupSettingUseCase from '@/usecases/group/FetchGroupSettingUseCase'
import FetchChildrenUseCase from '@/usecases/child/FetchChildrenUseCase'
import FetchCartQueryStatusUseCase from '@/usecases/event/FetchCartQueryStatusUseCase'
import SearchEventCartQueryPhotosUseCase from '@/usecases/event/SearchEventCartQueryPhotosUseCase'

// Components
import FormWrapper from '@/components/shared/organisms/FormWrapper'
import FormBlock from '@/components/shared/molecules/Form/FormBlock'
import Input from '@/components/shared/atoms/Input'
import LinkWithIcon from '@/components/shared/atoms/Icon/LinkWithIcon'
import Modal from '@/components/shared/atoms/Modal'
import SupportContentContainer from '@/containers/Support/Content'

interface IData {
  fields: Fields
  enableCheckFlg: { [key in keyof Fields]: boolean }
  showFAQModal: boolean
  FAQContentId: number | null
}

export default Vue.extend({
  components: {
    FormWrapper,
    FormBlock,
    Input,
    LinkWithIcon,
    Modal,
    SupportContentContainer
  },
  props: {
    eventId: {
      type: Number,
      required: true
    },
    devProps: {
      type: Object as () => {
        passwordEmpty?: boolean
        passwordInvalid?: boolean
        fullfilled?: boolean
      },
      default: null
    }
  },
  data(): IData {
    return {
      fields: {
        password: ''
      },
      enableCheckFlg: {
        password: false
      },
      showFAQModal: false,
      FAQContentId: null
    }
  },
  computed: {
    isFullfilled(): boolean {
      // TODO: 要改善
      const { password } = this.fields
      if (password === '') return false

      return true
    },
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)
      return UnlockEventValidator.validate(targetFields)
    },
    canSubmit(): boolean {
      const hasUnlockPasswordErrors = Object.values(this.formErrors).some(field => field.length !== 0)
      return this.isFullfilled && !hasUnlockPasswordErrors
    }
  },
  created() {
    const devProps = this.devProps
    if (devProps) {
      if (devProps.passwordEmpty) {
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          password: true
        }
      }
      if (devProps.passwordInvalid) {
        this.fields = {
          ...this.fields,
          password: 'ほげ'
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          password: true
        }
      }
      if (devProps.fullfilled) {
        this.fields = {
          ...this.fields,
          password: 'correctPassword'
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          password: true
        }
      }
    }
  },
  methods: {
    openFAQModal(id: number) {
      this.FAQContentId = id
      this.showFAQModal = true
    },
    enableCheck(str: keyof Fields) {
      this.enableCheckFlg[str] = true
    },
    enableAllChecks() {
      Object.keys(this.fields).forEach(field => this.enableCheck(field as keyof Fields))
    },
    async unlockPassword() {
      this.enableAllChecks()

      if (!this.canSubmit) return

      const unlockEvent = new UnlockEventUseCase({
        snapsnapGateway: this.$snapsnapGateway,
        eventRepository: this.$eventRepository
      })

      const usecaseParams = {
        snapsnapGateway: this.$snapsnapGateway,
        eventRepository: this.$eventRepository
      }

      const loadEvent = new LoadEventUseCase({
        fetchEventUseCase: new FetchEventUseCase(usecaseParams),
        fetchEventAlbumsUseCase: new FetchEventAlbumsUseCase(usecaseParams),
        searchEventUchinokoPhotosUseCase: new SearchEventUchinokoPhotosUseCase(usecaseParams),
        fetchGroupsUseCase: new FetchGroupsUseCase({
          snapsnapGateway: this.$snapsnapGateway,
          groupRepository: this.$groupRepository
        }),
        fetchSchoolsUseCase: new FetchSchoolsUseCase({
          snapsnapGateway: this.$snapsnapGateway,
          groupRepository: this.$groupRepository
        }),
        fetchGroupSettingUseCase: new FetchGroupSettingUseCase({
          snapsnapGateway: this.$snapsnapGateway,
          groupRepository: this.$groupRepository
        }),
        fetchChildrenUseCase: new FetchChildrenUseCase({
          snapsnapGateway: this.$snapsnapGateway,
          groupRepository: this.$groupRepository
        }),
        fetchCartQueryStatusUseCase: new FetchCartQueryStatusUseCase({
          snapsnapGateway: this.$snapsnapGateway,
          eventRepository: this.$eventRepository
        }),
        searchEventCartQueryPhotosUseCase: new SearchEventCartQueryPhotosUseCase({
          snapsnapGateway: this.$snapsnapGateway,
          eventRepository: this.$eventRepository
        }),
        groupRepository: this.$groupRepository
      })

      const { password } = this.fields

      try {
        await unlockEvent.execute({ eventId: this.eventId, password })

        // パスワード解除に成功したらイベント関連情報を再読み込み
        await loadEvent.execute({ eventId: this.eventId })
      } catch (e) {
        this.$toastRepository.addQueue({
          type: 'error',
          text: '閲覧パスワードが異なります'
        })
      }
    }
  }
})
